'use strict';
import angular from 'angular';

angular.module('core.history.constants', [])

    .constant('HistoryTypes', {
        UPDATE: 'update',
        CREATE: 'create',
        DELETE: 'delete'
    });